/* eslint-disable camelcase */
import { Chakra } from "@airhelp/react-ui-components";
import type { AirportScore } from "services/scores";
import { SCORE_RANKING_COLORS } from "../../styles";

const { Text } = Chakra;

const rankCellCallback = ({
  row: {
    original: { rank },
  },
}) => <Text as="span">{rank}.</Text>;

const locationAccessorCallback = (d: {
  dep_city_name: AirportScore["dep_city_name"];
  dep_airport_country_name: AirportScore["dep_airport_country_name"];
}) => `${d.dep_city_name} ${d.dep_airport_country_name}`;

const locationCellCallback = ({
  row: {
    original: { dep_city_name: depCityName, dep_airport_country_name: depAirportCountryName },
  },
}) => <Text as="span">{`${depCityName}, ${depAirportCountryName}`}</Text>;

const airportScoreCellCallback = ({
  row: {
    original: { rank, airport_score: airportScore },
  },
}) => (
  <Text
    as="span"
    px={2}
    py={1}
    bg={SCORE_RANKING_COLORS[rank]}
    rounded="5px"
    color={rank <= 3 ? "white" : "inherit"}
    maxW="min-content"
  >
    {airportScore.toFixed(2)}
  </Text>
);

const columns = [
  {
    Header: "",
    accessor: "rank",
    disableSortBy: true,
    Cell: rankCellCallback,
  },
  { Header: "airline", accessor: "dep_airport_name", disableSortBy: true },
  {
    Header: "location",
    accessor: locationAccessorCallback,
    disableSortBy: true,
    Cell: locationCellCallback,
  },
  {
    Header: "airhelp_score",
    accessor: "airport_score",
    Cell: airportScoreCellCallback,
  },
  { Header: "on_time_performance", accessor: "on_time_performance" },
  { Header: "service_quality", accessor: "skytrax_score" },
  { Header: "food_and_shops", accessor: "quality_of_retail" },
];

export default columns;
